import React from "react";
import { useLanguage } from "../../../context/LanguageContext";

const ListAcoustic = (): React.ReactElement => {
  const { t } = useLanguage();
  
  return (
    <div>
      <h1>{t('pages.acoustic.listOffers')}</h1>
      <p>{t('common.welcome')}</p>
    </div>
  );
};

export default ListAcoustic;